<script setup lang="ts">
import { ref } from 'vue'
import { fasArrowRight } from '@quasar/extras/fontawesome-v6'
const email = ref('')
const firstName = ref('')
const lastName = ref('')
const loading = ref(false)
const signUp = ref(false)
const success = ref(false)

function attemptLogin() {
  fetch(`${import.meta.env.VITE_API_URL}/auth/magicLink`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ destination: email.value })
  })
    .then((response) => {
      if (response.status === 404) signUp.value = true
      else if (response.status === 200) success.value = true
      return response.json()
    })
    .then((data) => console.log(data))
    .catch((error) => {
      console.error('There has been a problem with your fetch operation:', error)
    })
    .finally(() => {
      loading.value = false
    })
}

function signUpRequest() {
  const payload = {
    email: email.value,
    firstName: firstName.value,
    lastName: lastName.value
  }
  console.log(payload)
  setTimeout(() => {
    loading.value = false
  }, 5000)
}

function onSubmit() {
  loading.value = true
  if (signUp.value) signUpRequest()
  else attemptLogin()
}
</script>

<template>
  <q-card class="text-white shadow-12" style="background: radial-gradient(circle, #35a2ff 0%, #014a88 100%)" bordered>
    <q-card-section id="login" v-if="!success">
      <q-form @submit="onSubmit">
        <q-input
          v-model="email"
          filled
          standout
          type="email"
          hint="Email"
          :rules="[(val) => !!val || 'Field is required']"
        />
        <q-input
          v-if="signUp"
          v-model="firstName"
          filled
          standout
          type="text"
          hint="firstName"
          :rules="[(val) => !!val || 'Field is required']"
        />
        <q-input
          v-if="signUp"
          v-model="lastName"
          filled
          standout
          type="text"
          hint="lastName"
          :rules="[(val) => !!val || 'Field is required']"
        />
        <q-btn
          class="full-width"
          :icon="fasArrowRight"
          label="Login"
          :loading="loading"
          :disable="loading"
          color="white"
          outline
          align="center"
          type="submit"
        />
      </q-form>
    </q-card-section>
    <q-card-section id="login" v-if="success">
      <h4>Check your email for the magic link to login.</h4>
    </q-card-section>
  </q-card>
</template>
